<template>
  <v-card class="ma-10" flat tile>
    <v-row>
      <month-picker v-model="month" label="Select Month"></month-picker>
      <v-spacer />

      <div class="d-flex ">
        <v-btn
          @click="printReport"
          class="elevation-0"
          color="primary"
          outlined
          elevation="2"
        >
          <v-icon left> mdi-printer</v-icon>
          Print</v-btn
        >
      </div>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="contractViews"
      :items-per-page="10"
      :loading="loading"
    ></v-data-table>
  </v-card>
</template>

<script>
import { axios, Strings } from '../../../utils'
import MonthPicker from '../../../components/MonthPicker'
export default {
  components: {
    MonthPicker
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'BUSINESS NAME',
          align: 'start',
          sortable: true,
          value: 'client.business_name'
        },
        {
          text: 'CLIENT NAME',
          align: 'start',
          sortable: true,
          value: 'client.client_name'
        },
        {
          text: 'MOBILE',
          align: 'start',
          sortable: true,
          value: 'client.mobile'
        },
        {
          text: 'EMAIL',
          align: 'start',
          sortable: true,
          value: 'client.mobile'
        },

        {
          text: 'START DATE',
          align: 'start',
          sortable: true,
          value: 'start_date'
        },
        {
          text: 'END DATE',
          align: 'start',
          sortable: true,
          value: 'end_date'
        }
      ],
      contractViews: [],
      month: ''
    }
  },
  mounted() {
    this.getContractViews()
  },
  methods: {
    getContractViews() {
      this.loading = true
      axios
        .get(
          `/api/admin/contracts/expiring?month=${
            this.month ? this.month : new Date().toISOString().substr(0, 7)
          }`
        )
        .then(res => {
          this.contractViews = res.data
          this.loading = false
        })
        .catch(err => console.log(err))
    },
    printReport() {
      window.open(
        `${Strings.baseUrl}/print-report?month=${
          this.month ? this.month : new Date().toISOString().substr(0, 7)
        }&type=contract&name=EXPIRING CONTRACTS REPORT`,
        '_blank'
      )
    }
  },
  watch: {
    month: function() {
      this.getContractViews()
    }
  }
}
</script>

<style lang="scss" scoped></style>
